module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_Arsenal.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_Arsenal.png
// module id = 2075
// module chunks = 4